export const SUPPORT_MESSAGE_SENDER_NAME_LENGTH_MIN = 1;
export const SUPPORT_MESSAGE_SENDER_NAME_LENGTH_MAX = 100;
export const SUPPORT_MESSAGE_SENDER_EMAIL_LENGTH_MAX = 100;
export const SUPPORT_MESSAGE_LENGTH_MIN = 4;
export const SUPPORT_MESSAGE_LENGTH_MAX = 1000;
export const SUPPORT_MESSAGE_ATTACHMENT_FILE_SIZE_MAX = 1e7;
